<span class="password-toggle-wrapper">
  <ng-content></ng-content>
  <span (click)="toggle()" class="password-toggle-eye" [inlineSVG]="passwordVisible?'/assets/svg/hide.svg':'/assets/svg/show.svg'"></span>
</span>
